module.exports = __webpack_public_path__ + "assets/ziyuan.8106bc22.svg";